<template>
<div>
  <b-button id="dismiss" @click="dismiss" size="sm"><i class='mdi mdi-window-close'></i></b-button>
  <div class="sidebar-header">
      <span class="navbar-brand">Dashboard</span>
  </div>

  <ul class="list-unstyled components">
      <li :class="activePage.includes('account/dashboard') ? activeClass : ''">
          <router-link data-cy="dashboard" :to="{ name: 'dashboard' }" @click.native="dismiss"><i class='mdi mdi-calendar-clock'></i> Events</router-link>
      </li>
      <li :class="activePage.includes('account/drip') ? activeClass : ''">
          <router-link data-cy="drips" :to="{ name: 'drips' }" @click.native="dismiss"><i class='mdi mdi-water-outline'></i> Drip Campaigns</router-link>
      </li>
      <li :class="activePage.includes('portal') ? activeClass : ''">
        <router-link data-cy="portal" :to="/portal/ + this.$store.getters.userProfile.clientUsername" @click.native="dismiss"><i class='mdi mdi-view-dashboard'></i> My Landing Page</router-link>
      </li>
      <li :class="activePage === '/' ? activeClass : ''">
        <router-link data-cy="home" to="/" @click.native="dismiss"><i class='mdi mdi-calendar-account-outline'></i> Enrolled Events</router-link>
      </li>
  </ul>
  <ul class="list-unstyled components">
      <li :class="activePage.endsWith('account/templates') ? activeClass : ''">
        <router-link data-cy="templates" :to="{ name: 'templates' }" @click.native="dismiss"><i class='mdi mdi-view-module'></i> Templates</router-link>
      </li>
      <template v-if="this.isOwner()">
      <li :class="activePage.includes('account/subscription') ? activeClass : ''">
        <router-link data-cy="account" :to="{ name: 'subscription' }" @click.native="dismiss"><i class='mdi mdi-account'></i> Account</router-link>
      </li>
      </template>
      <template v-if="this.isAdmin()">
      <li :class="activePage.includes('account/settings') ? activeClass : ''">
        <router-link data-cy="settings" :to="{ name: 'settings' }" @click.native="dismiss"><i class='mdi mdi-file-cog-outline'></i> Settings</router-link>
      </li>
      </template>
      <!-- <template v-if="this.authorizedSeller === true"> -->
      <li :class="activePage.includes('account/contributor') ? activeClass : ''">
        <router-link data-cy="contributor" :to="{ name: 'contributor' }" @click.native="dismiss"><i class='mdi mdi-group'></i> Contributor</router-link>
      </li>

      <!-- </template> -->

      <!-- <li :class="activePage.includes('help') ? activeClass : ''">
        <a href="https://www.facebook.com/groups/myeventcafe" target="_new"><i class='mdi mdi-facebook'></i> Facebook Support</a>
      </li> -->
      <li v-if="showWebhooks" :class="activePage.endsWith('account/webhooks') ? activeClass : ''">
        <router-link data-cy="webhooks" :to="{ name: 'webhooks' }" @click.native="dismiss"><i class='mdi mdi-webhook'></i> Webhooks</router-link>
      </li>
      <li :class="activePage.endsWith('account/landingpages') ? activeClass : ''">
        <router-link data-cy="editLandingPages" :to="{ name: 'editLandingPages' }" @click.native="dismiss"><i class='mdi mdi-note-multiple-outline'></i> Landing Pages
        <svg v-if="isDateInFuture(new Date('2023-04-15'))" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"  width="24" height="24"><path d="M20,4C21.11,4 22,4.89 22,6V18C22,19.11 21.11,20 20,20H4C2.89,20 2,19.11 2,18V6C2,4.89 2.89,4 4,4H20M8.5,15V9H7.25V12.5L4.75,9H3.5V15H4.75V11.5L7.3,15H8.5M13.5,10.26V9H9.5V15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5M20.5,14V9H19.25V13.5H18.13V10H16.88V13.5H15.75V9H14.5V14A1,1 0 0,0 15.5,15H19.5A1,1 0 0,0 20.5,14Z" /></svg>
        </router-link>
      </li>
  </ul>
  <ul class="list-unstyled components">
    <template v-if="this.isOwner()">
      <li :class="activePage.includes('account/event/sales') ? activeClass : ''">
        <router-link data-cy="eventSalesHistory" :to="{ name: 'eventSalesHistory' }" @click.native="dismiss"><i class='mdi mdi-currency-usd'></i> Event Sales</router-link>
      </li>
    </template>
    <template v-if="this.isOwner()">
      <li :class="activePage.endsWith('account/templates/sales') ? activeClass : ''">
        <router-link data-cy="templateSalesHistory" :to="{ name: 'templateSalesHistory' }" @click.native="dismiss"><i class='mdi mdi-currency-usd'></i> Template Sales</router-link>
      </li>
    </template>
    <li :class="activePage.endsWith('purchase/templates') ? activeClass : ''">
      <router-link data-cy="templatesForSale" :to="{ name: 'Templates For Sale' }" @click.native="dismiss"><i class='mdi mdi-file-image-outline'></i> Buy Templates</router-link>
    </li>
  </ul>
  <ul class="list-unstyled">
    <li :class="activePage.includes('help') ? activeClass : ''">
      <a href="https://support.myeventcafe.com" target="_new"><i class='mdi mdi-help-circle-outline'></i> Online Help <i class='mdi mdi-open-in-new'></i></a>
    </li>
    <!-- <li :class="activePage.includes('help') ? activeClass : ''">
      <a @click="scheduleSupport()" style="cursor:pointer;"><i class='mdi mdi-message-text-clock'></i> Schedule a Chat</a>
    </li> -->
  </ul>
</div>
</template>

<style>
.calendly-overlay {
  background-color: rgba(31, 31, 31, .8) !important
}
</style>

<script>
import { clientServices } from '@/_services'
export default {
  data () {
    return {
      activeClass: 'active',
      authorizedSeller: false,
      client: null
    }
  },
  methods: {
    dismiss () {
      this.$emit('dismissClick')
    },
    isOwner () {
      return this.$store.getters.isOwner
    },
    isAdmin () {
      return this.$store.getters.isAdmin || this.$store.getters.isOwner
    },
    scheduleSupport () {
      // &hide_event_type_details=1',
      console.log(this.$store.getters.userProfile)
      // eslint-disable-next-line
      Calendly.initPopupWidget(
        {
          url: 'https://calendly.com/rebecca-myeventcafe/30min?hide_gdpr_banner=1',
          prefill: {
            name: this.$store.getters.userProfile.name,
            email: this.$store.getters.userProfile.email
          }
        })
    },
    isDateInFuture (date) {
      console.log(date.toDateString() + ' > ' + new Date().toDateString())
      console.log(new Date(date.toDateString()) > new Date(new Date().toDateString()))
      return new Date(date.toDateString()) > new Date(new Date().toDateString())
    }
  },
  computed: {
    activePage () {
      return this.$route.path
    },
    isBetaTester () {
      return this.client && this.client.betaTester === true
    },
    showWebhooks () {
      return true
      // return this.$store.getters.userProfile.email.includes('zapier.com') || this.$store.getters.userProfile.email.includes('dropsoffreedom.com')
    }
  },
  mounted () {
    clientServices.getByOwner()
      .then(result => {
        console.log('Client: ', result)
        this.client = result
        this.authorizedSeller = result.isAuthorizedSeller
      })
  }
}
</script>
